import { render, staticRenderFns } from "./SkillsForPeopleFilters.vue?vue&type=template&id=167e250e"
import script from "./SkillsForPeopleFilters.vue?vue&type=script&lang=js"
export * from "./SkillsForPeopleFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports